import styled from 'styled-components';

export const TextStyled = styled.p`
  margin: 0;
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));

  ${({ breakWords }) => breakWords && 'overflow-wrap: anywhere;'}

  ${({ inactive }) =>
    inactive && {
      'font-weight': 400,
      'font-style': 'italic',
      'padding-right': '2px',
    }}

  ${({ noData }) =>
    noData && {
      color: 'var(--ds-text-subtle, var(--ds-fb-text-subtle))',
      'font-style': 'italic',
    }}
    
  ${({ fontSize }) => {
    switch (fontSize) {
      case 'xsmall':
        return 'font-size: 11px;';
      case 'small':
        return 'font-size: 14px;';
      default:
        return 'font-size: 14px;';
    }
  }};
`;
